import { render, staticRenderFns } from "./YearlyRankTitle.vue?vue&type=template&id=11f32be4&scoped=true"
import script from "./YearlyRankTitle.vue?vue&type=script&lang=js"
export * from "./YearlyRankTitle.vue?vue&type=script&lang=js"
import style0 from "./YearlyRankTitle.vue?vue&type=style&index=0&id=11f32be4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f32be4",
  null
  
)

export default component.exports